export default {
  metaTitle: 'Product-level Delivery Fee',
  pageTitle: 'Product-level Delivery Fee',
  country: '配置国家',
  placeholder1: 'Listing#输入',
  check: 'Check',
  radio: '所选Listing:listing#',
  area: '应用到的区域',
  area1: '所有区域',
  area2: '所有区域运用统一的运费收取标准',
  area3: '逐一设置',
  area4: '为每一个城市各设一个运费',
  area5: '特殊设置',
  area6: '为指定的城市分别设置运费，其它的用统一设置',
  area7: '通常值',
  save: '保存',
  description1: '当前国家站平台设定运费策略为',
  description2: '无',
  description3: '本地自发货店铺尾程运费',
  description4: '非本地自发货店铺尾程运费',
  description5: '当前店铺为',
  description6: '运费执行',
  // -----
  description7: '中国发货订单运费收取',
  description8: '本地自发货店铺运费',
  description9: '本地非自发货店铺运费',
  description10: '本地仓代运营商品运费',
  typeList1: 'region',
  typeList2: 'city',
  typeList3: 'area',
  columns1: 'Area ID',
  columns2: 'Region',
  columns3: 'City',
  columns4: 'Area',
  columns5: 'TYPE',
  columns6: '值',
  error1: '请输入正确的listingId',
  error2: '请输入listingId',
  base: '基站',
  // -----
  result1: '由店铺设置',
  result2: '由平台定义为',
  result3: '由平台定义',
  result4: '由平台统收为',
  result5: '本地自发货店铺',
  result6: '非本地自发货店铺',
  result7: '由平台统收',
  // ----------
  store1: '中国发货店铺',
  store2: '本地自发货店铺',
  store3: '本地非自发货店铺',
  // error1: '请选择应用到的区域',
  // error2: '请输入listingId',
  error3: '请输入正确的收费标准',
  error4: '请填写收费标准',
  error5: 'Please Check',
  error6: '请逐一设置运费',
  error7: '设置值不能小于0',
  error8: '请设置通常值',
  success: 'Successfully'
}
